<template>
  <div class="group-events">
    <div class="group-events__wrapper">
      <NuxtTransformImage
        :src="'/assets/artnight/homepage/group-events/group-events.png'"
        alt="group-events"
        fit="cover"
      />
      <div class="group-events__details">
        <h2 class="group-events__title">
          {{ $t('homepage.group_events.title') }}
        </h2>
        <p class="group-events__text">{{ $t('homepage.group_events.text') }}</p>
        <NuxtLink class="group-events__link" :to="'/gruppenevents/artnight-firmenevents'"
          >{{ $t('event.bundles.more_link') }}
        </NuxtLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const NuxtTransformImage = defineAsyncComponent(() => import('@/components/molecules/NuxtTransformImage.vue'));
</script>

<style lang="scss" scoped>
@use '@/assets/styles/css_BASE/helpers/mixins/font-size.scss' as *;
@use '@/assets/styles/css_BASE/helpers/mixins/_bp.scss' as *;

.group-events {
  color: white;
  background-color: #c0bdf5;

  &__wrapper {
    // border: solid red 2px;
    display: flex;
    flex-direction: column;
    @include bp(sm) {
      flex-direction: row;
      height: 280px;
    }
    @include bp(sm) {
      flex-direction: row;
      margin: auto;
    }
    @include bp(md) {
      flex-direction: row;
      margin: auto;
    }
    @include bp(lg) {
      flex-direction: row;
      justify-content: flex-end;
      width: 60%;
      height: 390px;
      margin: auto;
    }
  }

  &__details {
    width: 100%;
    min-height: 280px;
    margin-top: -10px;
    padding: 50px;
    display: flex;
    flex-direction: column;
    background: center / cover no-repeat url('/assets/artnight/homepage/group-events/bg-group-events.png');
    @include bp(sm) {
      height: 280px;
      margin-top: 0px;
      padding: 30px;
      background: center / cover no-repeat url('/assets/artnight/homepage/group-events/bg-group-events-desktop.png');
      justify-content: center;
    }

    @include bp(md) {
      height: 390px;
      margin-top: 0px;
      min-height: 390px;
      overflow: visible;
      padding: auto;
      justify-content: center;
      background: center / cover no-repeat url('/assets/artnight/homepage/group-events/bg-group-events-desktop.png');
    }
    @include bp(lg) {
      height: 390px;
      min-height: 390px;
      margin-top: 0px;
      padding: 50px;
      justify-content: center;
      background: top / contain no-repeat url('/assets/artnight/homepage/group-events/bg-group-events-desktop.png');
    }
  }

  &__title {
    @include font-size(30px);
    font-weight: 700;
    letter-spacing: -2%;
    margin-bottom: 20px;
    line-height: 36px;

    @include bp(lg) {
      width: 350px;
    }
  }

  &__text {
    @include font-size(18px);
    font-weight: 400;
    letter-spacing: 0%;
    margin-bottom: 20px;
    line-height: 130%;
    @include bp(lg) {
      width: 350px;
    }
  }

  &__link {
    margin-top: 10px;
    color: var(--color-night-blue-600);
    background: white;
    padding: 10px 20px;
    border-radius: 8px;
    @include font-size(14px);
    font-weight: 500;
    line-height: 20px;
    max-width: 140px;
  }
}
</style>
